/* Purchase selection UI only: no cart requests, checkout navigation or payment calls. */
(function () {
  'use strict';
  function init(scope) {
    var root = scope.querySelector ? scope.querySelector('[data-hmc]') : null;
    if (!root && scope.matches && scope.matches('[data-hmc]')) root = scope;
    if (!root) return;
    var box = root.querySelector('#hmc-s9');
    if (!box || box.dataset.buyboxReady) return;
    box.dataset.buyboxReady = 'true';
    var cards = Array.from(box.querySelectorAll('.hmc-offer'));
    var toggle = box.querySelector('[data-purchase-toggle]');
    var refill = root.querySelector('.hmc-refill-line');
    var originalRefill = refill ? refill.textContent : '';
    var atc = root.querySelector('#hmcAtc');
    var mode = 'subscription';
    var prefix = box.dataset.currencyPrefix;
    var currency = box.dataset.currency;
    function money(value) { return prefix + Number(value).toFixed(2); }
    function selected() { return cards.find(function (card) { return card.querySelector('input').checked; }) || cards[2]; }
    function sync() {
      var card = selected();
      cards.forEach(function (item) {
        var price = mode === 'onetime' ? item.dataset.onetimePrice : item.dataset.subscriptionPrice;
        item.dataset.mode = mode;
        item.dataset.price = Number(price).toFixed(2);
        item.dataset.priceCents = String(Math.round(Number(price) * 100));
        item.dataset.currency = currency;
        item.dataset.selected = String(item === card);
        item.classList.toggle('is-sel', item === card);
      });
      var quantity = card.dataset.bottles;
      box.dataset.purchaseMode = mode;
      box.dataset.bottles = quantity;
      box.dataset.price = card.dataset.price;
      box.dataset.priceCents = card.dataset.priceCents;
      if (atc) {
        atc.dataset.mode = mode;
        atc.dataset.bottles = quantity;
        atc.dataset.price = card.dataset.price;
        atc.dataset.priceCents = card.dataset.priceCents;
        atc.dataset.currency = currency;
      }
      box.querySelector('[data-onetime-selected-price]').textContent = money(card.dataset.onetimePrice);
      box.querySelector('[data-subscription-selected-price]').textContent = money(card.dataset.subscriptionPrice);
      box.querySelector('[data-selected-bottles]').textContent = quantity;
      box.querySelector('[data-selected-bottle-label]').textContent = quantity === '1' ? 'bottle' : 'bottles';
      if (refill) refill.textContent = mode === 'subscription' ? originalRefill : '✓ One-time order ✓ No refills, no subscription ✓ 90-day guarantee';
      toggle.setAttribute('aria-label', toggle.querySelector(mode === 'subscription' ? '[data-subscription-copy]' : '[data-onetime-copy]').textContent.trim());
    }
    cards.forEach(function (card) {
      var totalCents = Math.round(Number(card.dataset.onetimePrice) * 100);
      var perBottle = Math.round(totalCents / Number(card.dataset.bottles)) / 100;
      card.querySelector('[data-onetime-unit]').textContent = money(perBottle);
      card.querySelector('[data-onetime-total]').textContent = money(card.dataset.onetimePrice);
    });
    box.addEventListener('change', function (event) {
      if (event.target.matches('input[name="hmc-offer"]')) sync();
    });
    toggle.addEventListener('click', function () { mode = mode === 'subscription' ? 'onetime' : 'subscription'; sync(); });
    // Promotional bundle buttons show subscription gifts and prices. Keep the
    // purchase choice in step even after the buyer has selected one-time.
    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-buy]');
      if (!button) return;
      var quantity = button.getAttribute('data-buy');
      if (quantity === '2' || quantity === '4') {
        var offer = cards.find(function (card) { return card.dataset.offer === quantity; });
        if (offer) {
          mode = 'subscription';
          offer.querySelector('input[name="hmc-offer"]').checked = true;
        }
      }
      sync();
    });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
